import chatMessages from '../contact/messages';

const translations = {
  chat: chatMessages.fr,
  navigation: {
    expertise: "Expertises",
    projects: "Réalisations",
    team: "L'équipe",
    contact: "Contact",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
  },
  footer: {
    baseline: "Développeur d'apps mobiles",
    legalNotice: "Mentions légales",
    rights: "Tous droits réservés",
  },
  common: {
    contactUs: "Contactez-nous",
    encrypted: "chiffré",
    colon: "\u00a0:",
  },
  home: {
    hero: {
      title: "Développeur d'apps mobiles",
      text: "CDO Apps est votre partenaire privilégié pour la conception d’applications mobiles. Notre expertise exceptionnelle allie créativité, innovation et excellence technique.<br />Nous transformons vos idées en solutions mobiles performantes, offrant une expérience utilisateur exceptionnelle.",
    },
    figures: {
      collaborators: "Collaborateurs",
      years: "Années d'expérience",
      projects: "Projets réalisés",
    },
    services: {
      title: "Nos offres et services",
      subtitle: "Savoir-faire",
      fixedPrice: {
        title: "Forfait",
        description: "Contrôlez votre budget dès le départ avec nos forfaits. Nous collaborons sur un cahier des charges précis pour garantir transparence et conformité. Des solutions prêtes-à-l’emploi, adaptées à vos besoins.",
      },
      timeAndMaterials: {
        title: "Régie",
        description: "Contrôle total sur le processus de développement. Idéal pour les projets complexes, la régie offre une flexibilité maximale et une personnalisation complète.",
      },
      tailored: {
        title: "Solution sur mesure",
        description: "Solutions adaptées à vos besoins. Notre approche sur mesure permet une personnalisation complète, façonnant chaque aspect de votre application mobile selon vos exigences, pour une réponse parfaite à vos attentes.",
      },
    },
    skills: {
      title: "Nos compétences à votre service",
      subtitle: "Expertises",
      question: "Un projet\u00a0? Discutons-en\u00a0!",
    },
    projects: {
      title: "Nos dernières réalisations",
      subtitle: "Projets",
      all: "Voir toutes nos réalisations",
    },
    team: {
      title: "Qui sommes-nous\u00a0?",
      subtitle: "Dans les coulisses",
      text: "Nous sommes une équipe de passionnés, experts en développement d’applications mobiles. Notre mission est de transformer vos idées en solutions mobiles performantes, offrant une expérience utilisateur exceptionnelle. Nous mettons notre expertise et notre créativité à votre service pour concevoir des applications innovantes, intuitives et esthétiques, parfaitement adaptées à vos besoins.<br /><br />Nous sommes développeurs, designers, chefs de projet, experts en sécurité et en performance. Nous collaborons étroitement avec vous pour garantir la réussite de vos projets, de la conception à la livraison. Notre approche sur mesure et notre engagement total vous assurent des solutions mobiles de qualité exceptionnelle, répondant parfaitement à vos attentes.",
    },
    testimonials: {
      page: "Afficher la page {page} des témoignages",
      title: "Ils nous ont fait confiance",
      subtitle: "Références",
      quoteOpen: "«\u00a0",
      quoteClose: "\u00a0»",
      tayasui: {
        description: "Apps pour artistes",
        message: "Nous avons collaboré avec plusieurs studios depuis 15 ans et CDO Apps a été de loin notre meilleure expérience. Ensemble, nous avons développé des applications de premier plan pour iOS et Mac, toujours avec un grand souci du détail et une efficacité irréprochable. C'est une équipe talentueuse et ultra consciencieuse que nous recommandons absolument.",
      },
      jbk: {
        description: "Agence de communication",
        message: "Organisation, écoute et minutie ont été au coeur de notre collaboration avec CDO Apps. Tout au long de la mission c’est bien leur expertise technique autant que leur savoir-être qui nous ont permis d’avancer efficacement. Merci à toute l’équipe et à Clément.",
      },
      jetitnow: {
        description: "Location de jet privé",
        message: "CDO Apps a su répondre à nos attentes en nous proposant une solution sur mesure pour notre application mobile. Leur expertise technique et leur créativité ont été des atouts majeurs pour la réussite de ce projet.",
      },
    },
  },
  projects: {
    common: {
      description: "Description",
      technologies: "Technologies utilisées",
      website: "Voir le site de présentation",
      detailedDescription: "Description détaillée",
      role: "Rôle de CDO Apps",
      availableOn: "Disponible sur",
      includes: "{title} inclut\u00a0:",
      previous: "Précédent",
      next: "Suivant",
    },
  },
  team: {
    members: {
      internalTitle: "Notre équipe interne\u00a0:",
      internalText: "Chez CDO Apps, nous accompagnons nos clients de l’idée initiale jusqu’au produit final. Notre force réside dans une équipe soudée, capable de gérer l’ensemble du cycle de vie d’une application mobile, en assurant à la fois la qualité technique et le suivi de chaque projet.",
      externalTitle: "Nos experts de confiance\u00a0:",
      externalText: "Pour enrichir nos réalisations d’une dimension graphique, visuelle et sonore, nous collaborons avec des prestataires de confiance. Cette complémentarité garantit des applications à la fois performantes, intuitives et esthétiques, parfaitement adaptées à vos besoins.",
    },
  },
  pages: {
    home: {
      title: "Votre application mobile sur mesure | CDO Apps",
      description: "CDO Apps est un studio de développement d'applications mobiles sur mesure. Nous vous accompagnons de la conception à la publication sur les stores.",
    },
    projects: {
      title: "Nos réalisations | CDO Apps",
      description: "CDO Apps est reconnu pour la qualité de ses applications. Découvrez quelques-unes de nos réalisations pour nos clients et pour notre propre compte.",
      heading: "Nos réalisations",
      intro: "CDO Apps est reconnu pour la qualité de ses applications. Nous avons travaillé pour de nombreux clients et également développé des applications pour notre propre compte. Retrouvez ici quelques-unes de nos réalisations.",
      ctaTitle: "Vous avez une idée d'application en tête\u00a0?",
      ctaText: "Nous sommes là pour vous aider à la concrétiser. CDO Apps est spécialisé dans le développement d'applications mobiles. Nous vous accompagnons de la conception à la publication sur les stores. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
    },
    team: {
      title: "L'équipe | CDO Apps",
      description: "Découvrez l'équipe de CDO Apps, composée de designers, développeurs, graphistes... Nous travaillons ensemble pour vous proposer des applications mobiles au design unique et à la pointe de la technologie.",
      heading: "L'équipe",
      intro: "Nous travaillons essentiellement pour ceux qui utilisent nos créations. Nous sommes designers, développeurs, graphistes... Voici la somme de nos talents.",
      ctaTitle: "Votre projet nécessite une de nos compétences\u00a0?",
      ctaText: "Travaillons ensemble, CDO Apps est prêt à relever le défi\u00a0! Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé\u00a0: selon votre besoin, nous pourrons vous proposer une solution sur mesure incluant un plan de développement, un design personnalisé et un suivi de qualité.",
    },
    contact: {
      title: "Nous contacter | CDO Apps",
      description: "Vous avez besoin de réaliser une application mobile au design unique et à la pointe de la technologie\u00a0? N'hésitez pas à nous contacter, nous serons ravis de vous accompagner dans votre projet\u00a0!",
      heading: "Contact",
      intro: "Vous avez besoin de réaliser une application mobile au design unique et à la pointe de la technologie\u00a0?<br />N'hésitez pas à nous contacter, nous serons ravis de vous accompagner dans votre projet\u00a0!",
      constructionTitle: "Page en construction",
      constructionText: "Cette page est en cours de construction\u00a0: un chatbot sera bientôt disponible pour vous permettre de nous contacter directement depuis notre site web.<br /><br />En attendant, vous pouvez nous envoyer un email à l'adresse suivante\u00a0: {email}.",
    },
    legalNotice: {
      chatbotTitle: "Assistant IA et données de conversation",
      chatbotText: "Le chatbot vous aide à trouver une page du site ou à préparer un e-mail. Il est facultatif : vous pouvez nous écrire directement à {email}.<br /><br />Les messages que vous saisissez, les réponses précédentes utiles et des contenus publics du site sont transmis à OpenAI pour générer la réponse. Évitez de partager des informations confidentielles. L’assistant peut se tromper ; vous pouvez relire et modifier tout brouillon avant de l’envoyer vous-même depuis votre messagerie.<br /><br />Un cookie de session sert au fonctionnement du dialogue et à sa protection. L’historique est conservé temporairement sur notre serveur, expire après deux heures d’inactivité et est supprimé au prochain nettoyage (exécuté chaque heure) ou lors d’une nouvelle conversation. Aucun historique n’est conservé dans le stockage local de votre navigateur. Des compteurs techniques limitent les abus et les dépenses ; ils ne contiennent pas le texte des échanges.<br /><br />Nous désactivons le stockage des réponses pour consultation ultérieure dans l’API OpenAI. Cela ne supprime pas les éventuelles conservations techniques du fournisseur : consultez <a class=\"underline\" href=\"https://developers.openai.com/api/docs/guides/your-data\">les informations OpenAI sur le traitement des données</a>.<br /><br />Pour une question sur vos données ou une demande d’accès, de rectification ou de suppression, écrivez à {email}.",
      title: "Mentions légales | CDO Apps",
      description: "Découvrez les mentions légales du site de CDO Apps.",
      heading: "Mentions légales",
      editorTitle: "Éditeur",
      editorText: "CDO Apps est une SARL au capital de 5 000 €, immatriculée au Registre du Commerce et des Sociétés de Melun sous le numéro 825 071 905 00012.<br />Son siège social est situé au 27 rue de Belfort, 77340 Pontault-Combault.<br />TVA intracommunautaire\u00a0: FR 88 825 071 905.<br />Adresse email\u00a0: {email}.",
      publicationDirectorTitle: "Directeur de la publication",
      publicationDirectorText: "M. Clément Choquereau",
      hostingTitle: "Hébergeur",
      hostingText: "Le site est hébergé par la société OVH, SAS au capital de 50 000 000 €, immatriculée au RCS de Lille sous le numéro 424 761 419 00045 et dont le siège social est situé au 2 rue Kellermann, 59100 Roubaix.",
      contactTitle: "Contact",
      contactText: "Pour toute question ou réclamation concernant le site, vous pouvez contacter notre service client par email à l'adresse suivante\u00a0: {email}.",
      intellectualPropertyTitle: "Propriété intellectuelle",
      intellectualPropertyText: "Tous les éléments du site, qu'ils soient visuels ou sonores, y compris la technologie sous-jacente, sont protégés par le droit d'auteur, des marques ou des brevets. Ils sont la propriété exclusive de CDO Apps.<br />L'utilisateur qui dispose d'un site Internet à titre personnel et qui désire placer, pour un usage personnel, sur son site un lien simple renvoyant directement à la homepage du site de CDO Apps, doit obligatoirement en demander l'autorisation à CDO Apps. Il ne s'agira pas dans ce cas d'une convention implicite d'affiliation.",
      personalDataTitle: "Données personnelles",
      personalDataText: "Vous pouvez consulter ce site sans fournir votre identité. Si vous nous contactez, nous utilisons les informations que vous choisissez de transmettre pour traiter votre demande. Pour exercer vos droits d’accès, de rectification ou de suppression, contactez-nous à {email}. Le fonctionnement du chatbot est détaillé ci-dessous.",
      linksTitle: "Liens hypertextes",
      linksText: "Le site peut contenir des liens hypertextes vers d'autres sites. CDO Apps n'est pas responsable du contenu de ces sites.",
      lawTitle: "Loi applicable",
      lawText: "Le site est soumis à la loi française.",
    },
    notFound: {
      title: "Page introuvable | CDO Apps",
      description: "Désolé, la page que vous recherchez n'existe pas.",
      heading: "Page introuvable",
      text: "Désolé, la page que vous recherchez n'existe pas.",
    },
  },
  expertise: {
    common: {
      pageCta: "Parlez-nous de votre projet",
      description: "Description",
      role: "Notre rôle",
      learnMore: "En savoir plus",
      otherTitle: "Nos autres domaines d'expertise",
      otherSubtitle: "Expertises",
      otherQuestion: "Besoin d'une expertise pour votre projet ?",
      stackTitle: "Stack technique",
      processTitle: "Notre process",
    },
    mobileApps: {
      title: "Notre expertise en application mobile | CDO Apps",
      description: "Découvrez notre expertise en application mobile. Nous concevons des applications intuitives, esthétiques et parfaitement adaptées à diverses plateformes. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      heading: "Application mobile",
      intro: "CDO Apps excelle dans le développement d’applications mobiles de qualité exceptionnelle. Notre équipe créative et expérimentée maîtrise les dernières technologies pour concevoir des applications intuitives, esthétiques et parfaitement adaptées à diverses plateformes, offrant une expérience utilisateur fluide et engageante.",
      ctaTitle: "Un projet d'application mobile en tête\u00a0?",
      ctaText: "Nous sommes là pour vous aider à concrétiser votre projet. CDO Apps est spécialisé dans le développement d'applications mobiles. Nous vous accompagnons de la conception à la publication sur les stores. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      steps: [
        {
          title: "UI/UX Design",
          description: "L’expérience utilisateur est au cœur de nos préoccupations. Nous concevons des interfaces intuitives et ergonomiques pour offrir une expérience utilisateur fluide et agréable.",
        },
        {
          title: "Développement",
          description: "Notre équipe de développeurs expérimentés maîtrise les dernières technologies pour concevoir des applications mobiles performantes et fiables, respectant rigoureusement les maquettes et spécifications.",
        },
        {
          title: "Tests",
          description: "La qualité est notre priorité. Nous réalisons des tests rigoureux pour garantir le bon fonctionnement de vos applications sur toutes les plateformes et dans toutes les conditions.",
        },
        {
          title: "Publication",
          description: "Une fois votre application prête, nous nous occupons de sa publication sur les stores (App Store, Google Play) pour la rendre accessible au plus grand nombre d’utilisateurs.",
        },
      ],
    },
    backend: {
      title: "Notre expertise Back End | CDO Apps",
      description: "Découvrez notre expertise Back End. Nous assurons une base solide pour vos applications, de la gestion des bases de données à la sécurité avancée. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      heading: "Back end",
      intro: "La solidité d’une application réside dans son infrastructure. Avec notre expertise Back End, nous assurons une base solide pour vos applications. De la gestion efficace des bases de données à la sécurité avancée, nous optimisons les performances pour garantir une expérience utilisateur fiable et sécurisée.",
      ctaTitle: "Votre projet nécessite une expertise Back End\u00a0?",
      ctaText: "Nous sommes là pour vous aider à concevoir une base solide pour vos applications. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      steps: [
        {
          title: "Modélisation de données",
          description: "Dans une recherche de performance et de sécurité, la modélisation de données est une étape cruciale. Nous définissons la structure de vos bases de données pour garantir une gestion efficace des informations.",
        },
        {
          title: "Documentation API",
          description: "Pour faciliter l’intégration de vos applications, nous fournissons une documentation claire et détaillée de vos API. Cette documentation est également la base sur laquelle sera développée votre application front-end.",
        },
        {
          title: "Authentification",
          description: "La sécurité doit être une priorité. Nous mettons en place des systèmes d’authentification robustes pour protéger vos données et garantir l’accès uniquement aux utilisateurs autorisés.",
        },
        {
          title: "Déploiement",
          description: "Une fois votre application prête, nous assurons un déploiement efficace en deux phases\u00a0: un déploiement de test pour vérifier le bon fonctionnement de l’application, puis un déploiement final pour rendre votre application accessible au public.",
        },
      ],
    },
    graphics: {
      title: "Notre expertise en développement 3D | CDO Apps",
      description: "Découvrez notre expertise en développement 3D. Nous repoussons les limites de l'innovation en intégrant des technologies de pointe pour créer des simulations interactives et des expériences de jeu divertissantes. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      heading: "Développement 3D",
      intro: "Explorez de nouvelles dimensions avec l’expertise polyvalente de CDO Apps en développement 3D, moteur graphique et jeu vidéo. Nous repoussons les limites de l’innovation en intégrant des technologies de pointe pour créer des simulations interactives et des expériences de jeu divertissantes.",
      ctaTitle: "Votre projet nécessite du développement 3D\u00a0?",
      ctaText: "Nous sommes là pour vous aider à explorer de nouvelles dimensions avec notre expertise en développement 3D. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      steps: [
        {
          title: "Export 3D",
          description: "Vos éléments 3D doivent être exportés dans un format compatible avec les moteurs graphiques. Nous maîtrisons les formats de fichiers les plus courants et réalisons des outils de conversion personnalisés pour garantir une intégration parfaite.",
        },
        {
          title: "Moteur graphique",
          description: "Le moteur graphique est le cœur de vos projets 3D. Nous maintenons une connaissance à jour des moteurs graphiques que nous maîtrisons pour garantir des rendus de qualité et des performances optimales.<br /><br />Nous réalisons également des moteurs dédiés pour des projets spécifiques.",
        },
        {
          title: "Gameplay",
          description: "Lorsque votre projet nécessite une dimension interactive, le gameplay est un élément clé. Nous concevons des mécaniques de jeu innovantes et engageantes pour offrir une expérience utilisateur unique et divertissante.",
        },
        {
          title: "Optimisation",
          description: "L’optimisation est essentielle pour garantir le meilleur compromis entre un rendu le plus fidèle à vos attentes et des performances de premier plan. Nous optimisons modèles 3D, textures et shaders pour garantir une expérience utilisateur la plus fluide possible.",
        },
      ],
    },
    projectManagement: {
      title: "Notre expertise en gestion de projet | CDO Apps",
      description: "Découvrez notre expertise en gestion de projet. La réussite de chaque projet repose sur une gestion efficace. Notre expertise en gestion de projet assure une coordination transparente, du concept à la livraison. Nous maintenons une communication constante pour garantir la réalisation réussie de vos projets. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      heading: "Gestion de projet",
      intro: "La réussite de chaque projet repose sur une gestion efficace.<br />Notre expertise en gestion de projet assure une coordination transparente, du concept à la livraison. Nous maintenons une communication constante pour garantir la réalisation réussie de vos projets.",
      ctaTitle: "Vous avez besoin d'une gestion de projet efficace\u00a0?",
      ctaText: "Nous sommes là pour vous aider à coordonner et gérer vos projets de manière transparente. Contactez-nous pour discuter de votre projet et obtenir un devis personnalisé.",
      steps: [
        {
          title: "Spécifications",
          description: "La première étape de tout projet est la définition des spécifications. Nous travaillons en étroite collaboration avec vous pour définir vos besoins et objectifs, et établir un cahier des charges détaillé.",
        },
        {
          title: "Planification",
          description: "Une planification minutieuse est essentielle pour la réussite de tout projet. Nous établissons un calendrier précis et détaillé pour garantir une coordination efficace et respecter les délais.",
        },
        {
          title: "Suivi",
          description: "Nous utilisons des outils sécurisés pour gérer le code source et les versions du projet\u00a0: chaque modification est suivie et documentée, ce qui permet de maintenir un historique complet des changements.<br /><br />En parallèle, nous vous communiquons de façon constante l’avancement du projet pour vous tenir informé.",
        },
        {
          title: "Livraison",
          description: "Une fois le projet réalisé, nous procédons à sa livraison dans les délais convenus. Nous assurons également une période de garantie pour vous permettre de valider votre projet en conditions réelles selon les critères définis pendant la phase de spécifications.",
        },
      ],
    },
  },
};

export default translations;
